module.exports = __webpack_public_path__ + "media/styles/images/svg/inline-arrow-down-teal-2d164564573dc6d5f9fc3a6c3a9f6918.svg";